import React, { Fragment, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { centsToDollar } from '../../utils/formatters';
import ReturnsTable from './ReturnsTable';
import NewReturn from './NewReturn';
import { ReturnTypeMetricBreakdown } from '../../components';
import { AmountCountItem } from './CountAmountLineItem';

const styles = makeStyles((theme) => ({
    root: {
      },
      summaryContainer: {
        paddingLeft: '50px',
        paddingRight: '50px',
        width: '85vw'
      },
      summaryHeader: {
          textAlign: 'center'
      },
      summaryTotals: {
          paddingTop: '10px',
          paddingBottom: '10px'
      },
      summaryBody: {
        paddingTop: '10px',
        paddingBottom: '10px'
      },
      summary: {
        backgroundColor: theme.palette.grey.main,
        borderRadius: '5px',
        border: 'groove',
        borderColor: 'black',
        borderWidth: '0.5px',
      },
      table: {
          marginTop: '30px',
          width: '85vw',
          marginRight: '5vw'
      }
}));

const Returns = ({ dailyProcessingData, selectedDate }) => {
    const classes = styles();
    useTheme();

    const [showNewReturn, setShowNewReturn] = useState(false);
    const {returnsSummary, returns} = dailyProcessingData || {};

    const toggleShowNewReturn = () => setShowNewReturn(!showNewReturn);

    return dailyProcessingData === null ? (
        <h1>Loading...</h1>
      ) : (
        <Fragment>
            <Grid container direction="column">
                <Grid item className={classes.summaryContainer}>
                    <h3 className={classes.summaryHeader}>Summary</h3>
                    <Grid container direction="column" className={classes.summary}>
                        <Grid container justifyContent="space-evenly" className={classes.summaryBody}>
                            <Grid item className={classes.summaryTotals}>
                                <li>Total Returns: {returnsSummary[0].totalReturnAmount ? centsToDollar(returnsSummary[0].totalReturnAmount) : "$0"}</li>
                                <li>Total Returns Count: {returnsSummary[0].totalReturnNumber || 0}</li>
                                <br />
                                <li>Total Thread Returns: {returnsSummary[0].totalThreadReturnAmount ? centsToDollar(returnsSummary[0].totalThreadReturnAmount) : "$0"}</li>
                                <li>Total Thread Returns Count: {returnsSummary[0].totalThreadReturnNumber || 0}</li>
                                <br />
                                <li>Total WSFS Returns: {returnsSummary[0].totalWsfsReturnAmount ? centsToDollar(returnsSummary[0].totalWsfsReturnAmount) : "$0"}</li>
                                <li>Total WSFS Returns Count: {returnsSummary[0].totalWsfsReturnNumber || 0}</li>
                                <br />
                                <li>Total Non-Completed Returns: {returnsSummary[0].totalNonCompletedReturnAmount ? centsToDollar(returnsSummary[0].totalNonCompletedReturnAmount) : "$0"}</li>
                                <li>Total Non-Completed Returns Count: {returnsSummary[0].totalNonCompletedReturnNumber || 0}</li>
                                <br />
                                <li>Total Reprocessed Returns: {returnsSummary[0].totalReprocessedReturnAmount ? centsToDollar(returnsSummary[0].totalReprocessedReturnAmount) : "$0"}</li>
                                <li>Total Reprocessed Returns Count: {returnsSummary[0].totalReprocessedReturnNumber || 0}</li>
                            </Grid>

                            <Grid item className={classes.summaryTotals}>
                                <Grid item>
                                    <ReturnTypeMetricBreakdown
                                        loanType={'Home Improvement'}
                                        totalStat={returnsSummary[0].totalReturnAmountHi || 0}
                                        countStat={returnsSummary[0].totalReturnNumberHi || 0}
                                    />
                                </Grid>

                                <Grid item>
                                    <ReturnTypeMetricBreakdown
                                        loanType={'Healthcare'}
                                        totalStat={returnsSummary[0].totalReturnAmountHc || 0}
                                        countStat={returnsSummary[0].totalReturnNumberHc || 0}
                                    />
                                </Grid>
                            </Grid>


                            <Grid item className={classes.summaryTotals}>
                                <AmountCountItem label={"Issued Amount/Count"} amount={returnsSummary[0].issuedAmount} count={returnsSummary[0].issuedCount} boldLabel={false} />
                                <br />
                                <AmountCountItem label={"Processed Amount/Count"} amount={returnsSummary[0].processedAmount} count={returnsSummary[0].processedCount} boldLabel={false} />
                                <br />
                                <AmountCountItem label={"Bounced Amount/Count"} amount={returnsSummary[0].bouncedAmount} count={returnsSummary[0].bouncedCount} boldLabel={false} />
                            </Grid>
                        </Grid>
                        <Grid container justifyContent="space-evenly" className={classes.summaryBody}>
                            <Grid item>
                            {returns.some((returnItem) => {
                                return returnItem.noPaymentsCompleted === true;
                            }) ? (
                                <Grid>
                                    <p><b><u>Alerts</u></b></p>
                                    <li>A return exists for a loan that has had no payments completed yet.</li>
                                </Grid>
                            ) : null}</Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={classes.table}>
                    <ReturnsTable returns={returns} selectedDate={selectedDate} toggleShowNewReturn={toggleShowNewReturn} />
                </Grid>
            </Grid>
            <NewReturn showNewReturn={showNewReturn} toggleShowNewReturn={toggleShowNewReturn} selectedDate={selectedDate} />
        </Fragment>
    );
}

export default Returns;
